module.exports = __webpack_public_path__ + "static/media/F_FI_18-07-26_HyQvia.4ecd26e7.pdf";